<template>
    <div class="agent-page">
        <div style="display: flex; flex-direction: column; text-align: start;">
            <h2 class="page-title" style="font-size: 15px;">企业采购--公开招标项目流程--招标项目编号：E1101050893002128　招标项目名称：中山大厦项目</h2>
            <div style="display: flex; align-items: center; justify-content: space-between;">
                <h2 class="page-title" style="margin-top: 10px;">{{ type == 'edit' ? '编辑招标公告' : '新增招标公告' }}</h2>
                <el-button type="primary" icon="el-icon-arrow-left" size="small" @click="handleBack">返回</el-button>
            </div>

        </div>

        <!-- 表单内容 -->
        <div class="content-wrap">
            <el-form :model="form" :rules="rules" ref="form" label-width="180px" class="announcement-form">
                <el-row :gutter="20">
                    <!-- 左列 -->
                    <el-col :span="12">
                        <!-- 公告名称 -->
                        <el-form-item label="公告名称:" prop="announcementName" required>
                            <el-input v-model="form.announcementName" placeholder="请输入公告名称"
                                style="width: 100%;"></el-input>
                        </el-form-item>

                        <!-- 公告发布时间 -->
                        <el-form-item label="公告发布时间:" prop="announcementReleaseTime" required>
                            <app-date-picker v-model="form.announcementReleaseTime" type="datetime" placeholder="选择日期时间"
                                style="width: 100%;" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                            </app-date-picker>
                        </el-form-item>

                        <!-- 招标文件获取开始时间 -->
                        <el-form-item label="招标文件获取开始时间:" prop="documentAcquisitionStartTime" required>
                            <app-date-picker v-model="form.documentAcquisitionStartTime" type="datetime"
                                placeholder="选择日期时间" style="width: 100%;" format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss">
                            </app-date-picker>
                        </el-form-item>

                        <!-- 投标文件递交截止时间 -->
                        <el-form-item label="投标文件递交截止时间:" prop="bidSubmissionDeadline" required>
                            <app-date-picker v-model="form.bidSubmissionDeadline" type="datetime" placeholder="选择日期时间"
                                style="width: 100%;" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                            </app-date-picker>
                        </el-form-item>
                    </el-col>

                    <!-- 右列 -->
                    <el-col :span="12">

                        <!-- 公告结束时间 -->
                        <el-form-item label="公告结束时间:" prop="announcementEndTime" required>
                            <app-date-picker v-model="form.announcementEndTime" type="datetime" placeholder="选择日期时间"
                                style="width: 100%;" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                            </app-date-picker>
                        </el-form-item>

                        <!-- 招标文件获取截止时间 -->
                        <el-form-item label="招标文件获取截止时间:" prop="documentAcquisitionDeadline" required>
                            <app-date-picker v-model="form.documentAcquisitionDeadline" type="datetime"
                                placeholder="选择日期时间" style="width: 100%;" format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss">
                            </app-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 文件获取时间范围 -->
                <el-form-item label="文件获取时间范围:" prop="fileAcquisitionTimeRange" required>
                    <el-radio-group v-model="form.fileAcquisitionTimeRange">
                        <el-radio label="during_announcement">投标人只能在公告发布期内下载文件</el-radio>
                        <el-radio label="anytime">投标人可以在任意时间下载招标文件</el-radio>
                    </el-radio-group>
                </el-form-item>

                <!-- 是否需要投标人报名 -->
                <el-form-item label="是否需要投标人报名:" prop="needRegistration" required>
                    <el-radio-group v-model="form.needRegistration">
                        <el-radio label="no">否</el-radio>
                        <el-radio label="yes">是</el-radio>
                    </el-radio-group>
                </el-form-item>
                <!-- 报名资料表格 -->
                <el-form-item label="报名资料:" v-if="form.needRegistration === 'yes'">
                    <el-table :data="registrationDocuments" border style="width: 50%; margin-top: 10px;">
                        <el-table-column prop="index" label="#" width="60" align="center"></el-table-column>
                        <el-table-column prop="name" label="资料名称" min-width="150">
                            <template slot-scope="scope">
                                <el-input v-if="scope.row.isNew" v-model="scope.row.name" placeholder="名称"></el-input>
                                <span v-else>{{ scope.row.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="description" label="说明" min-width="150">
                            <template slot-scope="scope">
                                <el-input v-if="scope.row.isNew" v-model="scope.row.description"
                                    placeholder="说明"></el-input>
                                <span v-else>{{ scope.row.description }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="required" label="必传" width="100" align="center">
                            <template slot-scope="scope">
                                <el-checkbox v-if="scope.row.isNew" v-model="scope.row.required">是</el-checkbox>
                                <span v-else>{{ scope.row.required ? '是' : '否' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.isNew" type="text" @click="addDocument">+添加</el-button>
                                <el-button v-if="scope.$index > 0" type="text"
                                    @click="removeDocument(scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>

                <!-- 是否多标段 -->
                <el-form-item label="是否多标段:" prop="isMultiSection" required>
                    <el-radio-group v-model="form.isMultiSection">
                        <el-radio label="no">否</el-radio>
                        <el-radio label="yes">是</el-radio>
                    </el-radio-group>
                    <!-- 当选择"否"时显示上传按钮 -->
                    <el-upload
                        v-if="form.isMultiSection === 'no'"
                        :action="uploadUrl"
                        :on-success="handleSingleUploadSuccess"
                        :on-error="handleUploadError"
                        :before-upload="beforeUpload"
                        :show-file-list="false"
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                        style="display: inline-block; margin-left: 20px;">
                        <el-button type="primary" icon="el-icon-upload" size="small">上传招标文件</el-button>
                    </el-upload>
                </el-form-item>


                <!-- 多标段表格 -->
                <el-form-item label="多标段信息:" v-if="form.isMultiSection === 'yes'">
                    <el-table :data="multiSections" border style="width: 50%; margin-top: 10px;">
                        <el-table-column prop="index" label="#" width="60" align="center"></el-table-column>
                        <el-table-column prop="sectionName" label="标段名称" >
                            <template slot-scope="scope">
                                <el-input v-if="scope.row.isNew" v-model="scope.row.sectionName"
                                    placeholder="请输入标段名称"></el-input>
                                <span v-else>{{ scope.row.sectionName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作"  align="center">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.isNew" type="text" style="margin-right: 5px;"
                                    @click="addSection">+添加</el-button>
                                <el-button v-if="scope.$index > 0" type="text" style="margin-right: 5px;"
                                    @click="removeSection(scope.$index)">删除</el-button>
                                <el-upload  :action="uploadUrl"
                                    :on-success="(response, file, fileList) => handleUploadSuccess(response, file, fileList, scope.$index)"
                                    :on-error="handleUploadError" :before-upload="beforeUpload" :show-file-list="false"
                                    accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png" style="display: inline-block;">
                                    <el-button  icon="el-icon-upload" size="small">上传招标文件</el-button>
                                </el-upload>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>

                <!-- 公告内容 -->
                <el-form-item label="公告内容:" prop="announcementContent" required>
                    <RichTextEditor v-model="form.announcementContent" :height="400" placeholder="请输入公告内容..."
                        toolbar-type="default" />
                </el-form-item>

                <!-- 操作按钮 -->
                <el-form-item>
                    <el-button type="primary" @click="handleSubmit">暂存</el-button>
                    <el-button type="primary" @click="handleSubmit">保存并提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import RichTextEditor from '@/components/common/RichTextEditor.vue'

export default {
    name: 'AddTenderAnnouncement',
    components: {
        RichTextEditor
    },
    data() {
        return {
            type: '',
            form: {
                originalAnnouncementName: '',
                sectionName: '',
                announcementName: '',
                announcementReleaseTime: '',
                announcementEndTime: '',
                documentAcquisitionStartTime: '',
                documentAcquisitionDeadline: '',
                bidSubmissionDeadline: '',
                fileAcquisitionTimeRange: '',
                needRegistration: 'no',
                isMultiSection: 'no',
                announcementContent: ''
            },
            registrationDocuments: [
                {
                    index: 1,
                    name: '',
                    description: '',
                    required: true,
                    isNew: true
                },
            ],
            multiSections: [
                {
                    index: 1,
                    sectionName: '',
                    isNew: true
                },
            ],
            uploadUrl: '/api/upload', // 上传接口地址
            rules: {
                sectionName: [
                    { required: true, message: '请选择标段名称', trigger: 'change' }
                ],
                announcementName: [
                    { required: true, message: '请输入公告名称', trigger: 'blur' }
                ],
                announcementReleaseTime: [
                    { required: true, message: '请选择公告发布时间', trigger: 'change' }
                ],
                announcementEndTime: [
                    { required: true, message: '请选择公告结束时间', trigger: 'change' }
                ],
                documentAcquisitionStartTime: [
                    { required: true, message: '请选择招标文件获取开始时间', trigger: 'change' }
                ],
                documentAcquisitionDeadline: [
                    { required: true, message: '请选择招标文件获取截止时间', trigger: 'change' }
                ],
                bidSubmissionDeadline: [
                    { required: true, message: '请选择投标文件递交截止时间', trigger: 'change' }
                ],
                fileAcquisitionTimeRange: [
                    { required: true, message: '请选择文件获取时间范围', trigger: 'change' }
                ],
                needRegistration: [
                    { required: true, message: '请选择是否需要投标人报名', trigger: 'change' }
                ],
                isMultiSection: [
                    { required: true, message: '请选择是否多标段', trigger: 'change' }
                ],
                announcementContent: [
                    { required: true, message: '请输入公告内容', trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        this.type = this.$route.query.type
    },
    mounted() {
        this.type = this.$route.query.type
    },
    methods: {
        // 提交表单
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$confirm('确定要提交该招标公告吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        // 这里调用提交接口
                        this.$message.success('提交成功')
                    }).catch(() => {
                        this.$message.info('已取消提交')
                    })
                } else {
                    this.$message.error('请完善必填信息')
                    return false
                }
            })
        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 添加报名资料
        addDocument() {
            const newIndex = this.registrationDocuments.length + 1
            this.registrationDocuments.push({
                index: newIndex,
                name: '',
                description: '',
                required: true,
                isNew: true
            })
        },
        // 删除报名资料
        removeDocument(index) {
            this.registrationDocuments.splice(index, 1)
            // 重新编号
            this.registrationDocuments.forEach((doc, idx) => {
                doc.index = idx + 1
            })
        },
        // 添加多标段
        addSection() {
            const newIndex = this.multiSections.length + 1
            this.multiSections.push({
                index: newIndex,
                sectionName: '',
                isNew: true
            })
        },
        // 删除多标段
        removeSection(index) {
            this.multiSections.splice(index, 1)
            // 重新编号
            this.multiSections.forEach((section, idx) => {
                section.index = idx + 1
            })
        },
        // 上传前验证
        beforeUpload(file) {
            const isValidType = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'image/jpeg', 'image/jpg', 'image/png'].includes(file.type)
            const isLt10M = file.size / 1024 / 1024 < 10

            if (!isValidType) {
                this.$message.error('只能上传 PDF、Word、Excel、图片格式的文件!')
                return false
            }
            if (!isLt10M) {
                this.$message.error('上传文件大小不能超过 10MB!')
                return false
            }
            return true
        },
        // 上传成功回调
        handleUploadSuccess(response, file, fileList, index) {
            if (response.code === 200) {
                this.$message.success('上传成功')
                // 这里可以将文件信息保存到对应的标段数据中
                this.multiSections[index].uploadedFile = response.data
            } else {
                this.$message.error(response.message || '上传失败')
            }
        },
        // 上传失败回调
        handleUploadError(err, file, fileList) {
            this.$message.error('上传失败，请重试')
        },
        // 单标段上传成功回调
        handleSingleUploadSuccess(response, file, fileList) {
            if (response.code === 200) {
                this.$message.success('招标文件上传成功')
                // 这里可以将文件信息保存到表单数据中
                this.form.uploadedFile = response.data
            } else {
                this.$message.error(response.message || '上传失败')
            }
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/agent-common.css';

.page-title {
    color: #333;
    margin: 0;
    font-weight: bold;
}

.content-wrap {
    padding: 20px;
    border-radius: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
    background: white;

}

.announcement-form {
    .el-form-item {
        margin-bottom: 20px;
        text-align: start;

        .el-form-item__label {
            font-weight: 500;
            color: #333;
        }
    }
}

.registration-documents {
    margin-top: 20px;

    .section-title {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin: 0 0 10px 0;
        text-align: left;
    }
}
</style>
